module.exports = __webpack_public_path__ + "static/img/001_m.151b64f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/module/001_m.png
// module id = H9Dj
// module chunks = 0